import { TableHeaderCell } from 'common/components';
import type { TableFilterOption } from '../CallsTable';

type StatusCellProps = {
    filterStatus: string;
    statusOptions: TableFilterOption[];
    onFilterStatus: (value: string) => void;
};

export const StatusCell = ({ filterStatus, statusOptions, onFilterStatus }: StatusCellProps) => {
    const options = [{ value: '', label: 'All statuses' }, ...statusOptions];
    const selectedValues = filterStatus ? filterStatus.split(',').filter(Boolean) : [];

    return (
        <TableHeaderCell
            label='Status'
            isSearchable
            filterOptions={{
                mode: 'multi',
                options,
                selectedValues,
                onChange: (values) => onFilterStatus(values.join(',')),
            }}
        />
    );
};
